import { useMemo } from 'react';
import { FormAutoGenerated } from '@visualfabriq/vf-ui-kit';

import * as DataStagingStep from 'src/dto/PipelineStep/DataStagingStep';
import { requiredField } from 'src/components/UIKitTweaks';
import {
  FieldItem,
  FormLayoutRow,
} from '@visualfabriq/vf-ui-kit/dist/components/molecules/form/form-auto-generated/types';
import { splitWithTruncate } from 'src/utils/string/splitWithTruncate';

type CsvFileParametersProps = {
  parameters: DataStagingStep.CsvFileParameters;
  onUpdate: (parameters: DataStagingStep.CsvFileParameters) => void;
};

export function CsvFileParametersConfig(props: CsvFileParametersProps) {
  const { parameters, onUpdate } = props;

  const initData = useMemo<FormFields>(
    () => ({
      delimiter: parameters.delimiter ?? ',',
      escapechar: parameters.escapechar ?? '',
      fieldnames: parameters.fieldnames?.join(', ') ?? '',
      contains_header: parameters.contains_header ?? true,
    }),
    [],
  );

  const handleFormChange = (formData: FormFields) => {
    onUpdate({
      ...parameters,
      delimiter: formData.delimiter,
      escapechar: formData.escapechar,
      contains_header: formData.contains_header,
      fieldnames: formData.contains_header ? undefined : splitWithTruncate(formData.fieldnames),
    });
  };

  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <FormAutoGenerated initData={initData} fields={fields} layout={layout} onDataChange={handleFormChange as any} />
  );
}

const fields: FieldItem[] = [
  {
    field_id: 'delimiter',
    field_desc: 'Delimiter',
    data_type: 'text',
    ...requiredField,
  },
  {
    field_id: 'escapechar',
    field_desc: 'Escape Character',
    data_type: 'text',
  },
  {
    field_id: 'contains_header',
    field_desc: 'Contains Header',
    data_type: 'boolean',
    ...requiredField,
  },
  {
    field_id: 'fieldnames',
    field_desc: 'Field Names',
    placeholder: 'Enter a list of names separated by comma',
    data_type: 'text',
    edit_dependencies: [{ field_id: 'contains_header', values: [false] }],
    ...requiredField,
  },
];

const layout: FormLayoutRow[] = fields.map(({ field_id }) => [{ field: field_id, cols: [4, 6, 12] }]);

type FormFields = {
  delimiter: string;
  escapechar: string;
  fieldnames: string;
  contains_header: boolean;
};
